import AboutContent from '../components/About/AboutContent';
import CoreValues from '../components/About/CoreValues';
import TechStack from '../components/About/TechStack';

export default function AboutPage({ setActiveTab }) {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <AboutContent setActiveTab={setActiveTab} />
        <CoreValues />
        <TechStack />
      </div>
    </div>
  );
}